"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotionsCarousel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../../hooks");
const ModeCarousel_1 = require("../ModeCarousel");
function MotionsCarousel() {
    var _a;
    const tabContent = (0, hooks_1.useTabContent)(bridge_schema_1.InfoBoxTabType.Motion);
    const { items = [] } = tabContent;
    /* @todo Add motion thumbnails */
    // (items || []).forEach(item => {
    //   try {
    //     item.img = require(`assets/muscleMotionThumbnails/${item.img}`)
    //       .default as string;
    //   } catch (_) {}
    // });
    return ((0, jsx_runtime_1.jsx)(ModeCarousel_1.ModeCarousel, { type: bridge_schema_1.InfoBoxTabType.Motion, showImage: true, "data-e2e": 'MotionsCarousel_ModeCarousel', children: (_a = items === null || items === void 0 ? void 0 : items.map(item => (Object.assign(Object.assign({}, item), { detail: undefined })))) !== null && _a !== void 0 ? _a : [] }));
}
exports.MotionsCarousel = MotionsCarousel;
